import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useT } from "@/i18n";
import { cn } from "@/lib/utils";

export const ConfirmDialog = ({ open, onOpenChange, title, description, onConfirm, destructive, testId }) => {
  const { t } = useT();
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid={testId || "confirm-dialog"} className="rounded-surface">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-[16px] text-ink">{title}</AlertDialogTitle>
          <AlertDialogDescription className="text-[13px] text-ink-secondary">{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-cancel" className="rounded-control">
            {t("app.cancel")}
          </AlertDialogCancel>
          <AlertDialogAction
            data-testid="confirm-accept"
            className={cn(
              "rounded-control",
              destructive
                ? "border border-state-critical bg-transparent text-state-critical hover:bg-state-critical-soft"
                : "bg-brand text-paper hover:bg-brand-hover"
            )}
            onClick={onConfirm}
          >
            {t("app.confirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
